module.exports = __webpack_public_path__ + "img/emoji_songkouqi.258c7bef.png";